var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-select",
    {
      attrs: { placeholder: _vm.placeholder },
      on: { apply: _vm.applyFilter, close: _vm.onClose },
      scopedSlots: _vm._u([
        {
          key: "head",
          fn: function() {
            return [
              _vm.haveSelectedOptions
                ? _c("custom-select-tag-head", {
                    attrs: { title: _vm.tagTitle },
                    on: { clear: _vm.clear }
                  })
                : _vm._e()
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._t("default", null, {
        slot: "dropdown-content",
        add: _vm.addOption,
        remove: _vm.removeOption,
        options: _vm.options,
        selectedOptions: _vm.tempSelectedOptions
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }